export const DEFAULT_LOCALE = "en-US";

export const HOMEPAGE_MESSAGE_BUNDLE_NAME = "pages.homepage";

/** Cutoff period for stale GSLA recommendations (5 days in milliseconds) */
export const RECOMMENDATION_STALENESS_MS = 5 * 24 * 60 * 60 * 1000;
